<template>
	<a-modal :width="1100" dialogClass="pay-dialog" :footer="null" :closable="false" :visible="visible"
		@cancel="handleClose">
		<div class="line"></div>
		<div class="main">
			<div class="container">
				<div class="row">
					<div class="col-sm-12 col-md-12 col-lg-7">
						<div class="left">
							<div class="title">购买套餐</div>
							<div class="tip">全套软著申请材料(申请表、操作手册、源代码)，助您快速完成软著申请。</div>
							<div class="list">
								<div class="item" :class="{ active: item.id == currentId }" v-for="(item, index) in listData"
									:key="index" @click="handleClick(item)">
									<div class="img">
										<template v-if="item.id == 1">
											<img src="../assets/images/package-single.png" style="height: 70px;width: auto;" />
										</template>
										<template v-else>
											<img src="../assets/images/package-multiple.png" style="height: 70px;width: auto;" />
										</template>
									</div>
									<div class="content">
										<div class="tit">
											<span>{{ item.num }}</span>
											个软著项目
										</div>
										<div class="desc">
											<img src="../assets/images/package-item.png" />
											可生成和下载 {{ item.num }} 套完整软著申报材料
										</div>
									</div>
									<div class="price">
										<div class="single">
											<span>¥{{ item.price / item.num }}</span>/个
										</div>
										<div class="all">总价 ¥{{ item.price }}</div>
									</div>
								</div>
							</div>
							<div class="line"></div>
							<div class="contact">
								<div>
									<div class="tit">商务合作</div>
									<div class="desc">商务合作大批量采购，请联系我们或添加商务</div>
									<div class="phone">13365651124</div>
									<div class="time">
										<a-icon type="clock-circle" theme="filled"
											style="font-size: 12px;color: #C5C5C5;margin-right: 4px;" />
										工作日9:00 -18:00
									</div>
								</div>
								<div>
									<div class="ewm">
										<img src="../assets/images/ewm.png" style="width: 120px;height: 120px;" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-md-12 col-lg-5">
						<div class="right">
							<div class="title">
								<a-icon type="wechat" theme="filled" style="font-size: 22px;color: #09BB07;margin-right: 6px;" />
								微信扫码支付
							</div>
							<div class="ewm">
								<div class="img">
									<img :src="currentOrder.ewm" v-if="currentOrder.ewm" />
									<a-spin v-else />
								</div>
							</div>
							<div class="attr">
								<div class="label">订单号：</div>
								<div class="value">{{ currentOrder.no }}</div>
							</div>
							<div class="attr">
								<div class="label">套餐说明：</div>
								<div class="value">{{ currentOrder.desc }}</div>
							</div>
							<div class="attr">
								<div class="label">支付金额：</div>
								<div class="value price">¥{{ currentOrder.price }}</div>
							</div>
							<div class="btn" @click="handleClose">
								<a-icon type="reload" style="font-size: 16px;color: #fff;margin-right: 6px;" />
								我已支付
							</div>
							<div class="tip">支付即代表您已阅读并同意<span>购买协议</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</a-modal>
</template>
<script>
import { getPackageListApi, payPackageApi, payStatusApi } from '@/api/soft'

export default {
	name: 'PayDialog',
	computed: {
		isToken() {
			return this.$store.state.token
		},
		userInfo() {
			return this.$store.state.userInfo
		},
	},
	data() {
		return {
			visible: false,
			listData: [],
			currentId: 1,
			currentOrder: {
				no: '',
				ewm: '',
				desc: '',
				price: '',
			},
			payTimer: null
		}
	},
	methods: {
		// 弹窗 打开
		handleOpen() {
			this.visible = true
			this.getList()
		},
		// 弹窗 关闭
		handleClose() {
			this.getInfo()
			clearTimeout(this.payTimer)
			this.$emit('completed')
			this.visible = false
		},
		// 套餐 列表
		async getList() {
			if (!this.isToken) return
			const res = await getPackageListApi()
			if (res.code == 0) {
				let list = res.data.sort((a, b) => { return a.id - b.id })
				this.listData = list
				this.handleClick(list[0])
			}
		},
		// 套餐 点击
		handleClick(item) {
			this.currentId = item.id
			this.currentOrder = {
				no: '',
				ewm: '',
				desc: item.num + '套软著项目',
				price: item.price
			}
			this.handlePay()
		},
		// 套餐 购买
		async handlePay() {
			const res = await payPackageApi({
				servicePackageId: this.currentId
			})
			if (res.code == 0) {
				this.currentOrder.no = res.data.out_trade_no
				this.currentOrder.ewm = res.data.images_base64
				this.payTimer = setTimeout(() => {
					this.getPayStatus()
				}, 5000)
			}
		},
		// 套餐 支付状态
		async getPayStatus() {
			clearTimeout(this.payTimer)
			const res = await payStatusApi({
				out_trade_no: this.currentOrder.no
			})
			if (res.code == '0') {
				if (res.data.is_pay_success) {
					this.$message.success('支付成功')
					this.handleClose()
				} else {
					this.payTimer = setTimeout(() => {
						this.getPayStatus()
					}, 5000)
				}
			} else {
				this.$message.error('支付失败，请重新支付')
				const current = this.listData.find(e => e.id == this.currentId)
				this.handleClick(current)
			}
		},
		// 获取 用户信息
		getInfo() {
			this.$store
				.dispatch('GetInfo')
				.then(() => {
					// console.log('获取用户信息成功')
				})
				.catch(() => {
					// console.error('获取用户信息失败')
				})
		},
	},
}
</script>
<style lang="scss" scoped>
:deep .pay-dialog {

	.ant-modal-content {
		border-radius: 0;
	}

	.ant-modal-body {
		padding: 0;


		&>.line {
			width: 100%;
			height: 4px;
			background: linear-gradient(90deg, #7845ff, #ff4372);
		}

		&>.main {
			padding: 20px 10px 10px;
			background: linear-gradient(180deg, #E2E5FF 0%, #FFFFFF 100%);
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

			.left {
				padding: 0 10px;

				&>.title {
					font-size: 24px;
					font-weight: bolder;
					color: #333333;
				}

				&>.tip {
					margin: 10px 0 20px;
					font-size: 14px;
					color: #333333;
				}

				&>.list {
					.item {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 22px;
						padding: 16px 20px;
						background: #FFFFFF;
						border-radius: 10px;
						border: 1px solid #E1E4FF;
						cursor: pointer;

						.img {
							display: flex;
							justify-content: center;
							align-items: center;
							margin-right: 20px;
							width: 80px;
							height: auto;
						}

						.content {
							flex: 1;

							.tit {
								margin-bottom: 16px;
								font-size: 24px;
								color: #333;
								line-height: 1;

								span {
									font-size: 26px;
									color: #5B66FF;
								}
							}

							.desc {
								display: flex;
								align-items: center;
								font-size: 12px;
								line-height: 1;
								color: #5B66FF;

								img {
									width: 13px;
									height: auto;
									margin-right: 4px;
								}
							}
						}

						.price {
							.single {
								font-size: 16px;
								color: #888;

								span {
									font-size: 22px;
									font-weight: bolder;
									color: #5B66FF;
								}
							}

							.all {
								font-size: 12px;
								text-align: right;
								color: #999;
							}
						}
					}

					.active {
						border: 1px solid #5B66FF;
						box-shadow: 0px 12px 14px 0px rgba(91, 102, 255, 0.17);
					}

				}

				&>.line {
					margin: 30px 0 20px;
					width: 100%;
					height: 1px;
					background-color: #e9e9e9;
				}

				&>.contact {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 10px;

					.tit {
						margin-bottom: 6px;
						font-size: 18px;
						font-weight: bolder;
						color: #333333;
					}

					.desc {
						margin-bottom: 10px;
						font-size: 12px;
						color: #A3A3A3;
					}

					.phone {
						margin-bottom: 6px;
						font-size: 18px;
						color: #5B66FF;
					}

					.time {
						display: flex;
						align-items: center;
						font-size: 12px;
						color: #A3A3A3;
					}
				}
			}

			.right {
				height: 100%;
				padding: 20px;
				background: #FFFFFF;
				box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.06);
				border-radius: 18px;
				border: 1px solid #EBEBEB;

				&>.title {
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #333333;
				}

				&>.ewm {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 50px 0;

					.img {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 172px;
						height: 172px;
						border: 1px solid #5B66FF;
					}

					img {
						width: 170px;
						height: 170px;
					}
				}

				&>.attr {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 8px;
					font-size: 14px;
					color: #333333;

					.price {
						color: #FF3333;
					}
				}

				&>.btn {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 30px 0 10px;
					width: 100%;
					height: 40px;
					background-color: #5B66FF;
					font-size: 16px;
					color: #fff;
					border-radius: 6px;
				}

				&>.tip {
					font-size: 12px;
					text-align: center;
					color: #999999;

					span {
						text-decoration: underline;
					}
				}
			}
		}
	}
}
</style>
